import api from "src/services/api";

/**
 * Servicio self-contained del modulo "Asignaciones (nuevo)".
 * Reusa los mismos endpoints Flask que el modulo Gestiones, pero recibe los
 * parametros de forma explicita (sin depender de sessionStorage) para que las
 * pantallas estilo EMSYS sean independientes del flujo viejo.
 */
const AsignacionesV2Service = {
  // Lista de puntos de servicio asignados al fiscal (con cantidad de operarios).
  async listaPuntos() {
    try {
      const resp = await api.get(`asignacion/puntos_operarios_asignados`);
      return resp?.data?.datos || [];
    } catch (error) {
      return [];
    }
  },

  // Cupos del PS: { cupo_asignado, cupo_hora, cupo_restante } por tipo de hora.
  async cupos(psId) {
    try {
      const resp = await api.get(`punto_servicio/cupo_horas/${psId}`);
      const datos = resp?.data?.datos;
      if (Array.isArray(datos) && datos.length > 0) {
        return {
          asignado: datos[0]?.cupo_asignado || {},
          hora: datos[0]?.cupo_hora || {},
          restante: datos[0]?.cupo_restante || {},
        };
      }
      return { asignado: {}, hora: {}, restante: {} };
    } catch (error) {
      return { asignado: {}, hora: {}, restante: {} };
    }
  },

  // Operarios asignados al PS (operario, legajo, total_asignado).
  async operarios(psId) {
    try {
      const resp = await api.get(`asignacion/operarios_asignados/${psId}`);
      return resp?.data?.datos || [];
    } catch (error) {
      return [];
    }
  },

  // Cortes (horario por dia) de un operario en el PS.
  async cortesOperario(psId, opId) {
    try {
      const resp = await api.get(`asignacion/asignaciones_detalle/${psId}?op_id=${opId}`);
      return resp?.data?.datos || [];
    } catch (error) {
      return [];
    }
  },

  // Candidatos disponibles rankeados con IA (SP + webhook n8n).
  async buscarCandidatos(filtros) {
    const params = new URLSearchParams();
    Object.keys(filtros || {}).forEach((k) => {
      const v = filtros[k];
      if (v !== undefined && v !== null && v !== "") {
        params.append(k, v);
      }
    });
    try {
      const resp = await api.get(`asignacion/buscar-operarios?${params.toString()}`);
      return resp?.data?.datos || [];
    } catch (error) {
      return [];
    }
  },

  // Motivo por el que un operario buscado (legajo/nombre) NO esta disponible.
  async motivoOperario(filtros) {
    const params = new URLSearchParams();
    Object.keys(filtros || {}).forEach((k) => {
      const v = filtros[k];
      if (v !== undefined && v !== null && v !== "") {
        params.append(k, v);
      }
    });
    try {
      const resp = await api.get(`asignacion/motivo-operario?${params.toString()}`);
      return resp?.data?.datos || [];
    } catch (error) {
      return [];
    }
  },

  // Crea la asignacion (replica el flujo de EMSYS via SP en el backend).
  async guardar(datos) {
    return api.post(`asignacion/guardar-asignacion`, datos);
  },

  // Cierra (cancela) un detalle de asignacion por id con una fecha fin.
  async cerrar(asigId, fechaFin) {
    return api.post(`asignacion/cerrar_asignaciones?asig_id=${asigId}&fecha_fin=${fechaFin}`);
  },

  // Edita campos de una asignacion existente (hoy: supervisor) con auditoria.
  async editarDetalle(asigDetId, cambios) {
    return api.post(`asignacion/editar-detalle`, { asig_det_id: asigDetId, ...cambios });
  },

  // Analisis de los ya asignados (propension al cambio) SP + IA via n8n.
  async analisisAsignados(psId, umbral = 0) {
    try {
      const resp = await api.get(`asignacion/analisis-asignados/${psId}?umbral=${umbral}`);
      return {
        datos: resp?.data?.datos || [],
        webhookAplicado: !!resp?.data?.webhook_aplicado,
      };
    } catch (error) {
      return { datos: [], webhookAplicado: false };
    }
  },

  // Lista de perfiles/especializaciones disponibles.
  async perfiles() {
    try {
      const resp = await api.get(`asignacion/perfiles`);
      return resp?.data?.datos || [];
    } catch (error) {
      return [];
    }
  },

  // Disponibilidad de beneficios (Tarjeta Gourmet / Viatico) del PS.
  async beneficios(psId) {
    try {
      const resp = await api.get(`asignacion/disponibilidad-beneficios/${psId}`);
      if (resp?.status === 200 && resp?.data?.datos) {
        return resp.data.datos;
      }
      return null;
    } catch (error) {
      return null;
    }
  },
};

export default AsignacionesV2Service;
